// // ExportUrduPDF.js
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { translateDict } from "./translateDict";

// const t = (text) => translateDict[text]?.trim() || text;

// const ExportUrduPDF = () => {
//   const [raw, setRaw] = useState([]);
//   const printRef = useRef();
//   const today = new Date().toISOString().split("T")[0];

//   useEffect(() => {
//     axios.get("https://ricgop.online/backend/getDuties.php").then((res) => {
//       setRaw(res.data);
//     });
//   }, []);

//   const exportPDF = async () => {
//     const canvas = await html2canvas(printRef.current, { scale: 2 });
//     const img = canvas.toDataURL("image/png");
//     const pdf = new jsPDF("l", "mm", "a4");
//     const props = pdf.getImageProperties(img);
//     const pdfH = (props.height * pdf.internal.pageSize.getWidth()) / props.width;
//     pdf.addImage(img, "PNG", 0, 0, pdf.internal.pageSize.getWidth(), pdfH);
//     pdf.save(`Duty-Roster-Urdu-${today}.pdf`);
//   };

//   return (
//     <div className="container mt-4">
//       <button className="btn btn-success mb-3" onClick={exportPDF}>
//         اردو PDF ایکسپورٹ کریں
//       </button>

//       <div
//         ref={printRef}
//         style={{
//           padding: 20,
//           direction: "rtl",
//           fontFamily: "'Noto Nastaliq Urdu', serif",
//           background: "#fff",
//         }}
//       >
//         <h3 style={{ textAlign: "center" }}>راولپنڈی انسٹی ٹیوٹ آف کارڈیالوجی</h3>
//         <h4 style={{ textAlign: "center" }}>ڈیوٹی روسٹر</h4>
//         <p style={{ textAlign: "center" }}>تاریخ: ({today})</p>

//         <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
//           <thead>
//             <tr>
//               <th style={{ textAlign: "center" }}>{t("#")}</th>
//               <th style={{ textAlign: "center" }}>{t("On Call")}</th>
//               <th style={{ textAlign: "center" }}>{t("Name")}</th>
//               <th style={{ textAlign: "center" }}>{t("Contact")}</th>
//             </tr>
//           </thead>
//           <tbody>
//             {raw.map((r, i) => (
//               <tr key={i}>
//                 <td style={{ textAlign: "center" }}>{t(`${i + 1}`)}</td>
//                 <td style={{ textAlign: "center" }}>{t(r.on_call)}</td>
//                 <td style={{ textAlign: "center" }}>{t(r.name)}</td>
//                 <td style={{ textAlign: "center" }}>{t(r.contact)}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ExportUrduPDF;







import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";



const translateText = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ur&dt=t&q=${encodeURIComponent(
        text
      )}`
    );
    const json = await res.json();
    return json?.[0]?.[0]?.[0] || text;
  } catch {
    return text;
  }
};

const ExportUrduPDF = () => {
  const [data, setData] = useState([]);
  const [urduData, setUrduData] = useState([]);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const fetchAndTranslate = async () => {
      setLoading(true);
      const { data: raw } = await axios.get(
        "https://ricgop.online/backend/getDuties.php"
      );
      setData(raw);

      const translated = await Promise.all(
        raw.map(async (row, i) => ({
          no: await translateText((i + 1).toString()),
          on_call: await translateText(row.on_call),
          name: await translateText(row.name),
          contact: await translateText(row.contact),
        }))
      );
      setUrduData(translated);
      setLoading(false);
    };
    fetchAndTranslate();
  }, []);

  const exportPDF = async () => {
    const canvas = await html2canvas(printRef.current, { scale: 2 });
    const img = canvas.toDataURL("image/png");
    const pdf = new jsPDF("l", "mm", "a4");
    const props = pdf.getImageProperties(img);
    const pdfH =
      (props.height * pdf.internal.pageSize.getWidth()) / props.width;
    pdf.addImage(img, "PNG", 0, 0, pdf.internal.pageSize.getWidth(), pdfH);
    pdf.save(`Duty-Roster-Urdu-${today}.pdf`);
  };

  return (
    
    <div className="container mt-4">
      <h5>📄 ڈیوٹی روسٹر (اردو)</h5>
      <button
        className="btn btn-success mb-3"
        onClick={exportPDF}
        disabled={loading}
      >
        {loading ? "ترجمہ ہو رہا ہے..." : "PDF ایکسپورٹ کریں"}
      </button>

      <div
        ref={printRef}
        style={{
          padding: 20,
          background: "#fff",
          direction: "rtl",
          fontFamily: "'Jameel Noori Nastaleeq', serif",
        }}
      >
        <h3 style={{ textAlign: "center" }}>
          راوَلپنڈی انسٹی ٹیوٹ آف کارڈیالوجی
        </h3>
        <h4 style={{ textAlign: "center" }}>ڈیوٹی روسٹر</h4>
        <p style={{ textAlign: "center" }}>تاریخ: {today}</p>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: 20,
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: 8 }}>نمبر</th>
              <th style={{ border: "1px solid #000", padding: 8 }}>ڈیوٹی</th>
              <th style={{ border: "1px solid #000", padding: 8 }}>نام</th>
              <th style={{ border: "1px solid #000", padding: 8 }}>رابطہ</th>
            </tr>
          </thead>
          <tbody>
            {urduData.map((r, i) => (
              <tr key={i}>
                <td style={{ border: "1px solid #000", padding: 8, textAlign: "center" }}>
                  {r.no}
                </td>
                <td style={{ border: "1px solid #000", padding: 8, textAlign: "center" }}>
                  {r.on_call}
                </td>
                <td style={{ border: "1px solid #000", padding: 8, textAlign: "center" }}>
                  {r.name}
                </td>
                <td style={{ border: "1px solid #000", padding: 8, textAlign: "center" }}>
                  {r.contact}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExportUrduPDF;
